module.exports = {
	"header": "Payment methods",
	"accepts": "$t(general::brand) accepts all major credit and debit cards.",
	"addCard": "Add a card",
	"cardAdded": "New card successfully added your account.",
	"cardholderName": "Cardholder name",
	"creditCard": "Credit card",
	"creditOrDebitCards": "Credit or Debit Cards",
	"creditCardNumber": "Credit card number",
	"cvc": "CVC",
	"defaultCard": "Default card",
	"editCardInfo": "Edit card information",
	"expiresOn": "Expires on",
	"nameOnCard": "Name on card",
	"noCard": "No credit or debit card.",
	"sources": {
		"amex": "American Express",
		"bchq": "Business Check",
		"btra": "Bank Transfer",
		"bdft": "Bank Draft",
		"cash": "Cash",
		"cchq": "Certified Check",
		"disc": "Discover",
		"goog": "Google Checkout",
		"maet": "Maestro",
		"mast": "MasterCard",
		"pchq": "Personal Check",
		"pypa": "Paypal",
		"visa": "Visa",
		"wsun": "Western Union",
		"wtra": "Wire Transfer"
	},
	"sourceTypes": {
		"card": "Credit Cards",
		"other": "Others"
	},
	"step": "Enter your credit card information (Step __step__ of __totalSteps__)",
	"stripeErrors": {
		"incorrectNumber": "The card number is incorrect.",
		"invalidNumber": "The card number is not a valid credit card number.",
		"invalidExpiryMonth": "The card's expiration month is invalid.",
		"invalidExpiryYear": "The card's expiration year is invalid.",
		"invalidCVC": "The card's security code is invalid.",
		"expiredCard": "The card has expired.",
		"incorrectCVC": "The card's security code is incorrect.",
		"incorrectZip": "The card's postal/zip code failed validation.",
		"cardDeclined": "The card was declined.",
		"default": "An error occurred while processing the card."
	},
	"updateCard": "Update card"
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/paymentMethods.json5
// module id = 1951
// module chunks = 6